module.exports = __webpack_public_path__ + "static/media/person_add.6e17aa36.svg";